import _get from 'lodash/get'

export default function getContactDetail(model, key) {
  return _get(model, `contactinfo.${key}`, false)
}
